
export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
    fixture: {
      type: Object,
      required: true,
    },
  },
  computed: {
    playerOn () {
      if (this.event.lineupOn) {
        return {
          number: this.event.lineupOn.shirtNumber,
          name: `${this.event.lineupOn.player.firstName} ${this.event.lineupOn.player.lastName}`,
        };
      }
      return null;
    },
    playerOff () {
      if (this.event.lineupOff) {
        return {
          number: this.event.lineupOff.shirtNumber,
          name: `${this.event.lineupOff.player.firstName} ${this.event.lineupOff.player.lastName}`,
        };
      }
      return null;
    },
  },
};
